import * as types from './mutation-types'
import { storeClient } from '@/service/apiClients'

export default {
  async setUserAsEmployee ({ rootGetters, commit }, email) {
    try {
      const { data: result } = await storeClient
        .post(`/stores/${rootGetters.storeId}/setUserAsEmployee/${email}`)
      commit(types.SET_EMPLOYEE_LIST, result.employees)
    } catch (e) {
      console.error(e)
    }
  },
  async getAllEmployees ({ rootGetters, commit }) {
    try {
      const { data: result } = await storeClient
        .get(`/stores/${rootGetters.storeId}/getAllEmployees`)
      commit(types.SET_EMPLOYEE_LIST, result.employees)
    } catch (e) {
      console.error(e)
    }
  }
}
